<template>
  <div class="c_discounts_container" v-if="newsArray && newsArray.length > 0">
    <div class="c_discounts"
         @mousedown="startDrag($event)"
         @touchstart="startDrag($event, true)"
         @mousemove.prevent="moveOnDrag($event)"
         @touchmove.prevent="moveOnDrag($event, true)"
         @mouseup="onDrop($event)"
         @mouseleave="onDrop($event)"
         @touchend="onDrop($event, true)"
         ref="scrollNewsContainer"
    >
      <div class="c_discount__block" v-for="item in newsArray">
        <img
            v-if="item.newsImages && item.newsImages.length > 0"
            style="position: absolute; z-index: 0; width: 100%; user-select: none;"
            draggable="false"
            :src="`${contentEndpoint}${item.newsImages[0].imageFileName}`"
            :alt="item.title">

        <div class="c_discount__data" :style="{backgroundImage: item.imgUrl ? `url(${item.imgUrl});` : ''}">
          <span class="c_discount__title">{{item.title}}</span>
          <span class="c_discount__description">{{item.description}}</span>
          <a class="c_discount__button" v-if="item.showButton && item.buttonUrl && item.buttonText" :href="item.buttonUrl">{{item.buttonText}}</a>
        </div>
      </div>
    </div>
    <div class="c_discount__counter" v-if="newsArray && newsArray.length > 1">
      <div
          class="c_discount__marker"
          v-for="(item, index) in newsArray"
          :class="{c_discount__marker_active: index === selectedIndex}"
          @click.prevent="scrollNewsToIndex(index)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Discounts",
  props:{
    newsArray:{
      type: Array,
      default: () => []
    }
  },
  data(){
    return {
      contentEndpoint: process.env.VUE_APP_CONTENT_URL + 'image/',
      selectedIndex: 0,
      dragging: false,
      startDragPos: 0,
      progressDragPos: 0,

      autoscrollInterval: null,
      resizeTimeout: null
    }
  },
  created() {
    window.addEventListener("resize", this.onWindowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  },
  mounted() {
    this.autoscrollInterval = setInterval(() => {
      this.scrollNext();
    }, 5000)
  },
  methods:{
    startDrag(evt, touch = false) {
      clearInterval(this.autoscrollInterval)
      this.dragging = true;
      if(!touch){
        this.startDragPos = evt.clientX;
      }else{
        this.startDragPos = evt.touches[0].clientX;
      }
      this.progressDragPos = this.startDragPos
    },
    moveOnDrag(evt, touch = false){
      if(this.dragging){
        let offset = 0;
        if(!touch) {
          offset = this.progressDragPos - evt.clientX;
        }else{
          offset = this.progressDragPos - evt.touches[0].clientX;
        }
        let scrollPos = this.$refs.scrollNewsContainer.scrollLeft;
        this.$refs.scrollNewsContainer.scrollLeft = scrollPos + offset

        if(!touch) {
          this.progressDragPos = evt.clientX;
        }else{
          this.progressDragPos = evt.touches[0].clientX;
        }
      }
    },
    onDrop(evt, touch = false) {
      if(this.dragging){
        if(this.startDragPos - this.progressDragPos > 50 && this.selectedIndex < this.newsArray.length - 1){
          this.selectedIndex += 1;
        }else if(this.startDragPos - this.progressDragPos < -50 && this.selectedIndex > 0){
          this.selectedIndex -= 1;
        }
        this.scrollNewsToIndex(this.selectedIndex);

        clearInterval(this.autoscrollInterval)
        this.autoscrollInterval = setInterval(() => {
          this.scrollNext();
        }, 5000)
      }
      this.dragging = false;
    },
    scrollNewsToIndex(index){
      if(this.$refs.scrollNewsContainer === null){
        return
      }
      if((index < this.newsArray.length) && index >= 0){
        this.selectedIndex = index;
        this.$refs.scrollNewsContainer.scrollLeft = this.$refs.scrollNewsContainer.clientWidth * index
      }
    },
    scrollNext(){
      if((this.selectedIndex >= this.newsArray.length - 1)){
        this.selectedIndex = 0;
      }else{
        this.selectedIndex += 1;
      }
      this.scrollNewsToIndex(this.selectedIndex)
    },
    onWindowResize(){
      clearTimeout(this.resizeTimeout)
      this.resizeTimeout = setTimeout(() => {
        this.scrollNewsToIndex(this.selectedIndex)
      }, 200)
    }
  }
}
</script>

<style scoped lang="scss">
  .c_discounts_container{
    width: 100%;
    height: max-content;
    position: relative;
  }

  .c_discounts{
    position: relative;
    display: flex;
    width: 100%;
    height: 20rem;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    cursor: grab;

    &:active{
      cursor: grab;
    }

    &::-webkit-scrollbar{
      width: 0;
      height: 0;
    }
  }

  .c_discount__counter{
    position: absolute;
    transform: translateX(-50%);
    width: max-content;
    height: 2rem;
    bottom: 0;
    left: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: .2rem;
  }

  .c_discount__marker{
    width: 1rem;
    cursor: pointer;
    height: 1rem;
    background-color: var(--theme-color-7);

    &_active{
      background-color: var(--dark-button-background);
      cursor: default;
    }
  }

  .c_discount__block{
    min-width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: var(--separator-color);
    padding: 1rem 0 1rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .c_discount__data{
    display: flex;
    box-shadow: var(--dark-button-background) 0 0 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem 4rem;
    color: var(--button-text-color);
    width: 70%;
    border-radius: 2rem;
    z-index: 1;
    height: max-content;
    background-color: var(--theme-color-7-60);
  }

  .c_discount__title{
    user-select: none;
    font-weight: 600;
    text-shadow: var(--dark-button-background) 2px 2px 4px;
    font-size: 2rem;
  }

  .c_discount__description{
    font-weight: 400;
    user-select: none;
    font-size: 1.4rem;
    text-shadow: var(--dark-button-background) 1px 1px 7px;
    margin-bottom: 1rem;
  }

  .c_discount__button{
    outline: none;
    text-decoration: none;
    cursor: pointer;
    color: var(--button-text-color);
    box-shadow: var(--dark-button-background) 0 0 4px;
    padding: 0.6rem 1.2rem;
    border-radius: .6rem;
    width: max-content;
    background: var(--theme-color-8);
    border: none;
  }

  @media screen and (max-width: 1280px) {
    .c_discounts{
      width: 100%;
      height: 18rem;
    }
  }

  @media screen and (max-width: 1200px) {
    .c_discount__data{
      width: 50%;
    }
  }

  @media screen and (max-width: 992px) {
    .c_discounts{
      width: 100%;
      height: 16rem;
    }
  }

  //MOBILE
  @media screen and (max-width: 768px) {
    .c_discounts{
      width: 100%;
      height: 14rem;
    }

    .c_discount__data{
      width: 100%;
      border-radius: 0;
      height: 100%;
      box-shadow: none;
    }

    .c_discount__block{
      padding: 0;
    }
  }
</style>